var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"rounded-lg grey"},[_c(_vm.layout,{tag:"component",staticClass:"rounded-lg white"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }